import { render, staticRenderFns } from "./OfferFormSettingsCard.vue?vue&type=template&id=72f5fea8&"
import script from "./OfferFormSettingsCard.vue?vue&type=script&lang=js&"
export * from "./OfferFormSettingsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports